import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

// icon
import { CiCalendar } from "react-icons/ci";
import { FiClock } from "react-icons/fi";

// images
import Newsimage1 from "./Images/newsbox image-1.svg";
import Newsimage2 from "./Images/newsbox image-2.svg";
import Newsimage3 from "./Images/newsbox image-3.svg";
import Whyjoinbg from "./Images/whyjoin-background.svg";
import ManImage from "./Images/whyjoinMan.svg";
import welcomeimage from "./Images/welocomeimage.svg";
import connectNowbg from "./Images/connectNowbg.svg";
import counterbg from "./Images/counterbg.svg";
import countericon1 from "./Images/countericon1.svg";
import countericon2 from "./Images/countericon2.svg";
import countericon3 from "./Images/countericon3.svg";
import countericon4 from "./Images/countericon4.svg";
import galleryimage1 from "./Images/galleryimage1.svg";
import galleryimage2 from "./Images/galleryimage2.svg";
import galleryimage3 from "./Images/galleryimage3.svg";
import galleryimage4 from "./Images/galleryimage4.svg";
import galleryimage5 from "./Images/galleryimage5.svg";
import galleryimage6 from "./Images/galleryimage6.svg";
import galleryimage7 from "./Images/galleryimage7.svg";
import galleryimage8 from "./Images/galleryimage8.svg";
import galleryimage9 from "./Images/galleryimage9.svg";
import galleryimage10 from "./Images/galleryimage10.svg";
import galleryimage11 from "./Images/galleryimage11.svg";
import galleryimage12 from "./Images/galleryimage12.svg";
import mediaimage1 from "./Images/mediaimage1.svg";
import mediaimage2 from "./Images/mediaimage2.svg";
import mediaimage3 from "./Images/mediaimage3.svg";
import mediaimage4 from "./Images/mediaimage4.svg";
import TestimonialImg from "./Images/TestimonialImg.svg";


import Sticky from "../../stickySide/Sticky";
import { motion } from "framer-motion";

import Sliders from "./Banner SLider/Sliders";

import { blogs } from "../../Blogs copy/BlogData";
import BlogList from "../../Blogs copy/BlogList";
import Testomonail from "./Testomonial/Testomonail";
import axios from "axios";
import Modal from "react-modal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

Modal.setAppElement("#root"); // Ensure modal accessibility

interface ImageData {
  image: string;
}


interface gallerydata{
  id:number,
  image:string,
}
const Homes = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const[galleryimagedata, setGalleryImagedata] = useState<gallerydata[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Open modal and set selected image index
  const openModal = (index: number) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<gallerydata[]>(
          `${api}/auth/gallery`
        );

        //console.log('gallery data',response.data)
        setGalleryImagedata(response.data);
      } catch (error) {
        console.error("gallery Not Found:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="gap-8 h-[100vh] flex justify-center bg-red-950
 items-center  flex-col ">
      {/* <Header /> */}
    
     
      <h1 className="text-3xl md:text-5xl font-bold text-center text-white leading-snug">
  Take a deep breath, stay with us—
  <br className="hidden md:block" />
  <span className="text-primary">something better is coming your way.</span>

  
</h1>
    <div className="w-[230px] h-[45px] bg-[#af8b2c]  flex justify-center items-center text-center text-white"onClick={()=>
                  window.location.href="/login"
                }>
      Login Now
    </div>



      {/* <Footer /> */}
    </div>
  );
};

export default Homes;
